// Shortens a filename for in-line display while keeping the extension visible,
// e.g. "A009_052616..._Step_4_CU.mp4". The full name is still surfaced via the
// tooltip/copy action, so this is purely cosmetic.
const transformFilename = (name, len = 24) => {
  if (typeof name !== 'string' || !name) return '';

  // Only treat a short trailing segment as a real extension, so a long
  // segment that merely follows an early dot isn't mistaken for one (which
  // previously caused the whole name to be returned untruncated).
  const lastDot = name.lastIndexOf('.');
  const hasExt =
    lastDot > 0 && lastDot < name.length - 1 && name.length - lastDot - 1 <= 5;
  const ext = hasExt ? name.slice(lastDot) : '';
  const pureName = hasExt ? name.slice(0, lastDot) : name;

  if (pureName.length <= len) {
    return `${pureName}${ext}`;
  }

  const head = Math.ceil((len - 3) / 2);
  const tail = Math.floor((len - 3) / 2);
  return `${pureName.slice(0, head)}...${pureName.slice(-tail)}${ext}`;
};

export default transformFilename;
